<div class="fq-container">

  <!-- ─── Action Bar ─── -->
  <div class="fq-action-bar">

    <!-- Search (left) -->
    <div class="fq-search-wrap">
      <input
        type="text"
        [(ngModel)]="search"
        (ngModelChange)="onSearchChange()"
        placeholder="Search questions or answers..."
        class="fq-input fq-input-search"
      />
      <button *ngIf="search" (click)="search = ''; page = 1" class="fq-clear-btn">&#x2715;</button>
    </div>

  </div>

  <!-- ─── Table ─── -->
  <div class="fq-table-wrap">

    <!-- Skeleton (loading) -->
    <table *ngIf="loading" class="fq-table">
      <thead>
        <tr>
          <th class="fq-th fq-th-num">Sr No</th>
          <th class="fq-th fq-th-session">Session ID</th>
          <th class="fq-th">Question</th>
          <th class="fq-th">Answer</th>
          <th class="fq-th fq-th-action">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sk of skeletonRows" class="fq-skeleton-row">
          <td class="fq-td"><div class="fq-sk fq-sk-xs"></div></td>
          <td class="fq-td"><div class="fq-sk fq-sk-session"></div></td>
          <td class="fq-td"><div class="fq-sk"></div></td>
          <td class="fq-td"><div class="fq-sk"></div></td>
          <td class="fq-td"><div class="fq-sk fq-sk-md" style="margin:0 auto"></div></td>
        </tr>
      </tbody>
    </table>

    <!-- Data Table -->
    <table *ngIf="!loading" class="fq-table">
      <thead>
        <tr>
          <th class="fq-th fq-th-num">Sr No</th>
          <th class="fq-th fq-th-session">Session ID</th>
          <th class="fq-th">Question</th>
          <th class="fq-th">Answer</th>
          <th class="fq-th fq-th-action">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of pageData; let idx = index"
          class="fq-tr"
          [ngClass]="getRowClass(row, idx)">

          <td class="fq-td fq-td-num">{{ getRowIndex(idx) }}</td>

          <td class="fq-td fq-td-session">
            <span class="fq-session-id" [title]="row.sessionId || ''">{{ row.sessionId || '—' }}</span>
          </td>

          <td class="fq-td">{{ row.question }}</td>

          <td class="fq-td">{{ row.answer }}</td>

          <td class="fq-td fq-td-action">
            <button class="fq-icon-btn fq-icon-btn-edit" (click)="openEditModal(row)" title="Edit">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </button>
            <button class="fq-icon-btn fq-icon-btn-delete" (click)="confirmDeleteRow(row.chatLogId)" title="Delete">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                <path d="M10 11v6M14 11v6"/>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>
          </td>
        </tr>

        <tr *ngIf="pageData.length === 0">
          <td colspan="5" class="fq-td fq-td-empty">No results found.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ─── Pagination ─── -->
  <div class="fq-pagination">
    <div class="fq-page-nav">
      <button class="fq-btn fq-btn-page" [disabled]="page === 1" (click)="page = page - 1">Prev</button>
      <button class="fq-btn fq-btn-page" [disabled]="page === totalPages" (click)="page = page + 1">Next</button>
      <span class="fq-page-info">Page {{ page }} of {{ totalPages }}</span>
    </div>

    <!-- Row count (center) -->
    <span class="fq-count">
      <ng-container *ngIf="search">{{ filtered.length }} of {{ data.length }} results</ng-container>
      <ng-container *ngIf="!search">{{ data.length }} results</ng-container>
    </span>

    <div class="fq-rows-wrap">
      <span class="fq-label">Rows per page</span>
      <select [(ngModel)]="rowsPerPage" (ngModelChange)="page = 1" class="fq-select">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
      </select>
    </div>
  </div>

</div>

<!-- ─── Edit Modal ─── -->
<div *ngIf="showEditModal" class="fq-overlay">
  <div class="fq-add-modal" (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="fq-add-header">
      <div class="fq-add-header-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
      </div>
      <span class="fq-add-title">Edit Response</span>
      <button class="fq-close-btn" (click)="closeEditModal()">&#x2715;</button>
    </div>

    <!-- Modal Body -->
    <div class="fq-add-body">
      <div class="fq-field">
        <label class="fq-field-label" for="editQuestion">Question</label>
        <textarea
          id="editQuestion"
          [(ngModel)]="editQuestion"
          placeholder="Enter question..."
          class="fq-textarea"
          rows="3">
        </textarea>
      </div>
      <div class="fq-field">
        <label class="fq-field-label" for="editAnswer">Answer</label>
        <textarea
          id="editAnswer"
          [(ngModel)]="editAnswer"
          placeholder="Enter answer..."
          class="fq-textarea"
          rows="4">
        </textarea>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="fq-add-footer">
      <button class="fq-btn fq-btn-secondary" (click)="closeEditModal()">Cancel</button>
      <button class="fq-btn fq-btn-primary" (click)="handleEdit()">Update</button>
    </div>
  </div>
</div>

<!-- ─── Confirm Delete Modal ─── -->
<div *ngIf="showDeleteModal" class="fq-overlay" (click)="showDeleteModal = false">
  <div class="fq-modal" (click)="$event.stopPropagation()">
    <p class="fq-modal-msg">
      Are you sure you want to delete this entry?
      This action cannot be undone.
    </p>
    <div class="fq-modal-actions">
      <button class="fq-btn fq-btn-secondary" (click)="showDeleteModal = false">Cancel</button>
      <button class="fq-btn fq-btn-danger" (click)="handleDelete()">Delete</button>
    </div>
  </div>
</div>

<!-- ─── Toasts ─── -->
<div class="fq-toasts">
  <div
    *ngFor="let t of toasts"
    class="fq-toast"
    [ngClass]="t.type === 'success' ? 'fq-toast-success' : 'fq-toast-error'">
    <span class="fq-toast-icon" [ngClass]="t.type === 'success' ? 'fq-icon-success' : 'fq-icon-error'">
      {{ t.type === 'success' ? '✓' : '✕' }}
    </span>
    <span class="fq-toast-text">{{ t.message }}</span>
  </div>
</div>
